import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { convertCssVariables } from "./auth-service-tools226.js";
import { useMantineStyleNonce, useMantineCssVariablesResolver } from "./auth-service-tools199.js";
import { useMantineTheme } from "./auth-service-tools196.js";
import { getMergedVariables } from "./auth-service-tools232.js";
import { removeDefaultVariables } from "./auth-service-tools233.js";

function getColorSchemeCssVariables(selector) {
  return `
  ${selector}[data-mantine-color-scheme="dark"] { --mantine-color-scheme: dark; }
  ${selector}[data-mantine-color-scheme="light"] { --mantine-color-scheme: light; }
`;
}

function MantineCssVariables(_ref) {
  let {
    cssVariablesSelector,
    deduplicateCssVariables
  } = _ref;
  const theme = useMantineTheme();
  const nonce = useMantineStyleNonce();
  const generator = useMantineCssVariablesResolver();
  const mergedVariables = getMergedVariables({
    theme,
    generator
  });
  const shouldCleanVariables = cssVariablesSelector === ":root" && deduplicateCssVariables;
  const cleanedVariables = shouldCleanVariables ? removeDefaultVariables(mergedVariables) : mergedVariables;
  const css = convertCssVariables(cleanedVariables, cssVariablesSelector);

  if (css) {
    return /* @__PURE__ */jsxRuntimeExports.jsx("style", {
      "data-mantine-styles": true,
      nonce: nonce == null ? void 0 : nonce(),
      dangerouslySetInnerHTML: {
        __html: `${css}${shouldCleanVariables ? "" : getColorSchemeCssVariables(cssVariablesSelector)}`
      }
    });
  }

  return null;
}

MantineCssVariables.displayName = "@mantine/CssVariables";
export { MantineCssVariables };